import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  activityState: '',
  callfeeTel: '',
  callfeeAppdate: '',
  HBPayFlag: 0
}
const getters = {
  getActivity (state) {
    return state.activityState
  },
  getCallfeeTel (state) {
    return state.callfeeTel
  },
  getCallfeeAppdate (state) {
    return state.callfeeAppdate
  },
  getHBPayFlag (state) {
    return state.HBPayFlag
  }
}
const mutations = {
  newActivity (state, acState) {
    state.activityState = acState
    localStorage.setItem('state', acState)
  },
  newCallfeeTel (state, ciftel) {
    state.callfeeTel = ciftel
    localStorage.setItem('callfeeTel', ciftel)
  },
  newCallfeeAppdate (state, appdate) {
    state.callfeeAppdate = appdate
    localStorage.setItem('callfeeAppdata', appdate)
  },
  newHBPayFlag (state) {
    state.HBPayFlag = '1'
  }
}
const actions = {
  changeHBPayFlag (context, hbpayflag) {
    context.commit('newHBPayFlag', hbpayflag)
  }
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js